import { TriangleAlert } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from 'slab'
import { usePostUsersOrganizationsSetCurrent } from 'utils/web_api'
import { useWindowLocation } from 'utils/windowLocation'

interface SwitchToEmployerButtonProps {
  employerId: string
  employerPath: string
}

const SwitchToEmployerButton = ({ employerId, employerPath }: SwitchToEmployerButtonProps) => {
  const setCurrentOrganizationMutation = usePostUsersOrganizationsSetCurrent()
  const { assign } = useWindowLocation()

  const handleSwitchToEmployer = async () => {
    await setCurrentOrganizationMutation.mutateAsync({
      data: { organization_type: 'employer', organization_id: employerId }
    })
      .then(() => {
        // Redirect to the specified employer path instead of reloading
        assign(employerPath)
      })
      .catch((error: Error) => {
        console.error('Failed to switch employers:', error)
        toast.error(
          'Failed to switch employers. If this issue persists, please contact support.',
          {
            dismissible: true,
            icon: <TriangleAlert className='w-5 h-5 text-yellow-400' />,
            position: 'top-right'
          }
        )
      })
  }

  return (
    <Button
      onClick={handleSwitchToEmployer}
      disabled={setCurrentOrganizationMutation.isPending}
      variant='secondary'
      size='large'
    >
      {setCurrentOrganizationMutation.isPending ? 'Loading...' : "Go to employer's admin page →"}
    </Button>
  )
}

export default SwitchToEmployerButton
